import React from 'react';
import classNames from 'classnames';
import Partners from '../../pages/my-events/Event/Header-new/Partners';
import Site from '../../pages/my-events/Event/Header-new/Site';
import Date from '../../pages/my-events/Event/Header-new/Date';
import Creator from '../../pages/my-events/Event/Header-new/Creator';
import Title from '../../pages/my-events/Event/Header-new/Title';
import StatusTags from '../../pages/my-events/Event/Header-new/StatusTags';
import Description from '../../pages/my-events/Event/Header-new/Description';
import Slots from '../../pages/my-events/Event/Header-new/Slots';
import Filled from '../../pages/my-events/Event/Header-new/Filled';
import Distance from '../../pages/events/Event/Distance';

export default function ComposableEventHeader(props) {
  const {
    event,
    tags,
    onClick,
    showTags = true,
    showTitle = true,
    showDescription = true,
    showDate = true,
    showSlots = true,
    showFilled = true,
    showCreator = true,
    showSite = true,
    showPartners = true,
    showDistance = false
  } = props;

  return (
    <div className="flex flex-col p-4 space-y-2">
      <div className="space-y-2">
        {tags}
        {showTags && (
          <StatusTags event={event} />
        )}
        <div
          className={classNames(
            'space-y-1 pr-10',
            onClick && 'cursor-pointer hover:text-cs-gray-500'
          )}
          onClick={onClick ? () => onClick(event) : undefined}
        >
          {showTitle && (
            <Title event={event} />
          )}
          {showDescription && (
            <Description event={event} />
          )}
        </div>
      </div>
      <div className="flex justify-between flex-wrap gap-x-4 gap-y-2">
        <div className="flex flex-wrap gap-x-4 gap-y-2">
          {showDate && (
            <Date event={event}/>
          )}
          {showSlots && (
            <Slots event={event}/>
          )}
          {showFilled && (
            <Filled event={event}/>
          )}
          {showCreator && (
            <Creator event={event}/>
          )}
          {showSite && (
            <Site event={event}/>
          )}
        </div>
        {showPartners && (
          <Partners event={event}/>
        )}
        {showDistance && (
          <Distance event={event}/>
        )}
      </div>
    </div>
  );
}
